import { Link } from "react-router-dom";
import { festival } from "../data/festival";
import { useTickets } from "../context/TicketsContext";
import { IconFacebook, IconInstagram, IconExternal } from "./icons";
import styles from "./Footer.module.css";

export default function Footer() {
  const { open: openTickets } = useTickets();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandCol}>
          <Link to="/" className={styles.brand}>
            <span className={styles.brandTop}>Rhythms</span>
            <span className={styles.brandBot}>on the Rio</span>
          </Link>
          <p className={styles.tag}>{festival.tagline}</p>
          <p className={styles.dates}>{festival.dates}</p>
          <p className={styles.dates}>{festival.city}</p>
          <button
            type="button"
            onClick={openTickets}
            className={styles.ticketsCta}
          >
            Buy Tickets <IconExternal />
          </button>
        </div>

        <div className={styles.col}>
          <h4 className={styles.h}>Festival</h4>
          <Link to="/about">About</Link>
          <Link to="/lineup">Lineup</Link>
          <Link to="/about/venue">Venue Info</Link>
          <Link to="/about/faq">FAQ</Link>
          <Link to="/about/press">Press</Link>
        </div>

        <div className={styles.col}>
          <h4 className={styles.h}>Participate</h4>
          <Link to="/participate/get-involved">Volunteer</Link>
          <Link to="/participate/vending">Vending</Link>
          <Link to="/participate/sponsors">Sponsors</Link>
          <Link to="/about/sfma">SFMA</Link>
          <Link to="/lineup/previous">Previous Lineups</Link>
        </div>

        <div className={styles.col}>
          <h4 className={styles.h}>Contact</h4>
          <a href={`mailto:${festival.email}`}>{festival.email}</a>
          <span className={styles.muted}>{festival.address}</span>
          <span className={styles.muted}>{festival.mailing}</span>
          <div className={styles.social}>
            <a href={festival.facebook} target="_blank" rel="noopener" aria-label="Facebook">
              <IconFacebook />
            </a>
            <a href={festival.instagram} target="_blank" rel="noopener" aria-label="Instagram">
              <IconInstagram />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.legal}>
        <span>© {new Date().getFullYear()} South Fork Music Association. A 100% volunteer-run nonprofit.</span>
        <span>Keeping music alive — one child at a time.</span>
      </div>
    </footer>
  );
}
